export default __webpack_public_path__ + "static/media/4.b298fad9.png";